import { Box, Heading, SimpleGrid, Text, Link, Icon, useColorModeValue } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";

const DocumentationOverview = () => {
  const sections = [
    { title: "Introduction", description: "Overview of the platform.", link: "/docs/introduction" },
    { title: "Getting Started", description: "How to set up and use the app.", link: "/docs/getting-started" },
    { title: "Features", description: "Explore the core functionalities.", link: "/docs/features" },
    { title: "API Reference", description: "Detailed API endpoints.", link: "/docs/api" },
    { title: "FAQ", description: "Common questions answered.", link: "/docs/faq" },
  ];

  // Define colors based on color mode (light/dark)
  const headingColor = useColorModeValue("teal.600", "teal.200");
  const boxBgColor = useColorModeValue("gray.100", "gray.700");
  const boxHoverBgColor = useColorModeValue("teal.50", "teal.600");
  const boxShadow = useColorModeValue("md", "lg");
  const linkColor = useColorModeValue("teal.500", "teal.300");

  return (
    <Box as="section" py={12} px={6} maxW="1200px" mx="auto">
      <Heading size="lg" textAlign="center" mb={8} color={headingColor}>
        Documentation Overview
      </Heading>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
        {sections.map((section, index) => (
          <Box
            key={index}
            p={6}
            bg={boxBgColor}
            borderRadius="md"
            boxShadow={boxShadow}
            _hover={{ bg: boxHoverBgColor, boxShadow: "lg" }}
          >
            <Heading size="md" mb={2} color={headingColor}>
              {section.title}
            </Heading>
            <Text mb={4} color={useColorModeValue("gray.700", "gray.200")}>
              {section.description}
            </Text>
            <Link
              href={section.link}
              color={linkColor}
              fontWeight="bold"
              display="inline-flex"
              alignItems="center"
              _hover={{ textDecor: "underline" }}
            >
              Read More <Icon as={ArrowForwardIcon} ml={2} />
            </Link>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default DocumentationOverview;
